import { render, staticRenderFns } from "./RelatedProductsModal.vue?vue&type=template&id=50b3dd00"
import script from "./RelatedProductsModal.vue?vue&type=script&lang=js"
export * from "./RelatedProductsModal.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductsModal.vue?vue&type=style&index=0&id=50b3dd00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports